export enum GuideType {
    STRAIGHT = 'straight',
    CURVED = 'curved',
    CUSTOM = 'custom',
    PROJECT = 'project',
}
